import { Injectable, Injector } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BaseService } from '../shared/services/base.service';
import { Planejamento } from '../models/planejamento.model';

@Injectable({
    providedIn: 'root'
})
export class PlanejamentoService extends BaseService<Planejamento> {

    constructor(protected injector: Injector) {
        super(`${environment.API_PRICE}/planeja`, injector);
    }
}
